@if (user()) {
    <button id="user-menu-toggle"
            class="after:tw-content-none"
            hlmBtn
            [brnMenuTriggerFor]="menu"
            align="end"
            variant="ghost"
            [size]="isMobile() ? 'icon' : 'default'"
            [attr.aria-label]="'AUTH.FEATURE_USER_MENU.ACTION.USER_MENU' | translate">
        @if (isMobile()) {
            <sona-icon name="dots-three-outline-vertical" appearance="fill" size="small"></sona-icon>
        } @else {
            {{ user()?.email }}
            <sona-icon class="tw-ml-2" name="caret-down" appearance="fill" size="tiny"></sona-icon>
        }
    </button>
    <ng-template #menu>
        <hlm-menu>
            <button hlmMenuItem (click)="openBillingPortal()">
                <div class="tw-mr-auto">
                    {{ 'AUTH.FEATURE_USER_MENU.ACTION.BILLING_PORTAL' | translate }}
                </div>
                <sona-icon class="tw-ml-4 tw-text-muted-foreground" name="arrow-square-out" size="tiny" />
            </button>

            <button hlmMenuItem sonaLanguageMenu (onLanguageUpdate)="updateUserLang($event)">
                <div class="tw-mr-auto">
                    {{ 'AUTH.FEATURE_USER_MENU.ACTION.LANGUAGE' | translate }}
                </div>
                <hlm-menu-item-sub-indicator />
            </button>

            <hlm-menu-separator />

            <button hlmMenuItem class="tw-text-destructive" (click)="signOut()">
                {{ 'AUTH.FEATURE_USER_MENU.ACTION.SIGN_OUT' | translate }}
            </button>
        </hlm-menu>
    </ng-template>
} @else {
    <div class="tw-flex tw-gap-2">
        <button hlmBtn variant="ghost" sonaLanguageMenu></button>
        <a hlmBtn routerLink="/auth">
            {{ 'AUTH.FEATURE_USER_MENU.ACTION.SIGN_IN' | translate }}
        </a>
    </div>
}